<div class="o-grid o-grid--wrap">
	<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-20@md-and-up o-grid__cell--w-15@lg-and-up">
		<ul class="c-stepper u-osb-lg@up-to-md u-ost-md@up-to-md">
			<li *ngFor="let step of vm.steps ; let $index=index" class="c-stepper__item" [ngClass]="{'c-stepper__item--current': step.id === vm.id, 'c-stepper__item--complete': step.isValid && step.id !== vm.id}">
				<a [routerLink]="['/symptom-check', step.id]" [queryParams]="vm.queryParams" (click)="vm.handleNavigation($event, $index)" class="c-stepper__link">
					<span class="c-stepper__label">{{step.label}}</span>
				</a>
			</li>
		</ul>
	</div>
	<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-80@md-and-up o-grid__cell--w-85@lg-and-up" [ngSwitch]="vm.id">
		<symptom-check-introduction *ngSwitchCase="'introduction'" [(interview)]="vm.interview" (interviewChange)="vm.interviewChanged($event)"></symptom-check-introduction>
		<symptom-check-patient *ngSwitchCase="'patient'" [(interview)]="vm.interview" (interviewChange)="vm.interviewChanged($event)"></symptom-check-patient>
		<symptom-check-factors *ngSwitchCase="'factors'" [(interview)]="vm.interview" (interviewChange)="vm.interviewChanged($event)"></symptom-check-factors>
		<symptom-check-symptoms *ngSwitchCase="'symptoms'" [(interview)]="vm.interview" (interviewChange)="vm.interviewChanged($event)"></symptom-check-symptoms>
		<symptom-check-regions *ngSwitchCase="'regions'" [(interview)]="vm.interview" (interviewChange)="vm.interviewChanged($event)"></symptom-check-regions>
		<symptom-check-interview *ngSwitchCase="'interview'" [(interview)]="vm.interview" (interviewChange)="vm.interviewChanged($event)"></symptom-check-interview>
		<symptom-check-results *ngSwitchCase="'results'" [interview]="vm.interview" [config]="vm.parentCategoryConfig"></symptom-check-results>
	</div>
</div>
<div class="o-grid o-grid--center-v o-grid--right u-ost-md" *ngIf="vm.isRecordTicketForPersonInWorkerView && !vm.endInterviewNotPossibleOnPages()">
	<div class="o-grid__cell o-grid__cell--w-fixed">
		<button id="openSummaryDialogButton" type="button" class="c-button c-button--s1 c-button--md" (click)="vm.openSummaryDialog()">
			{{ 'PreVisit.Symptom_Check.Notes_And_End_Interview' | translate }}
		</button>
	</div>
</div>
